import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from '@/services';
import { API_BUSINESS_URL } from '@/utils';

export type RoleRestriction = string;

export interface RoleApi {
  id: string;
  name: string;
  description?: string;
  restriction?: string;
  [key: string]: unknown;
}

const rolesService = createApi({
  reducerPath: 'businessRolesService',
  baseQuery: createBaseQueryWithReauth(`${API_BUSINESS_URL}/roles`),
  tagTypes: ['Roles'],
  keepUnusedDataFor: 30,
  endpoints: (builder) => ({
    getRoles: builder.query<RoleApi[], { restrictions?: RoleRestriction } | void>({
      query: (arg) => {
        const params: Record<string, string> = {};
        if (arg?.restrictions) {
          params.restrictions = arg.restrictions;
        }
        return {
          url: '',
          params,
        };
      },
      transformResponse: (response: RoleApi[] | { items: RoleApi[] }) =>
        Array.isArray(response) ? response : response.items ?? [],
      providesTags: ['Roles'],
    }),
  }),
});

export default rolesService;

export const { useGetRolesQuery } = rolesService;
